function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M259.414 129.832c0 71.637-58.074 129.707-129.707 129.707C58.07 259.54 0 201.47 0 129.832 0 58.199 58.07.125 129.707.125c71.633 0 129.707 58.074 129.707 129.707zm0 0",
  fill: "#c1dbdc"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M346.207 297.398h-10.875v-77.757h10.875c21.473 0 38.879 17.406 38.879 38.879 0 21.472-17.406 38.878-38.879 38.878zm0 0",
  fill: "#b5a19c"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M346.207 304.227h-10.875a6.818 6.818 0 01-6.824-6.825v-77.761a6.818 6.818 0 016.824-6.825h10.875c25.2 0 45.703 20.504 45.703 45.704s-20.504 45.707-45.703 45.707zm-4.047-13.653h4.047c17.672 0 32.05-14.379 32.05-32.054 0-17.672-14.378-32.051-32.05-32.051h-4.047zm0 0M197.973 123.008a6.822 6.822 0 01-6.825-6.828V68.395a6.822 6.822 0 016.825-6.829 6.825 6.825 0 016.828 6.829v47.785a6.825 6.825 0 01-6.828 6.828zm0 0",
  fill: "#4c241d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.531 219.64h14.133v77.758H52.531c-21.472 0-38.879-17.406-38.879-38.878 0-21.473 17.407-38.88 38.88-38.88zm0 0",
  fill: "#b5a19c"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.664 304.227H52.531c-25.199 0-45.703-20.508-45.703-45.707s20.504-45.707 45.703-45.707h14.133a6.825 6.825 0 016.828 6.828v77.757a6.823 6.823 0 01-6.828 6.829zm-14.133-77.762c-17.672 0-32.05 14.383-32.05 32.055s14.378 32.054 32.05 32.054h7.309v-64.11zm0 0",
  fill: "#4c241d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M311.473 375.594H91.3c-24.031 0-43.516-19.48-43.516-43.512V190.598c0-41.102 33.32-74.418 74.418-74.418H280.57c41.098 0 74.418 33.316 74.418 74.418v141.484c0 24.031-19.484 43.512-43.515 43.512zm0 0",
  fill: "#edebdc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M311.473 382.422H91.3c-27.762 0-50.34-22.582-50.34-50.34V190.594c0-44.793 36.445-81.242 81.238-81.242h158.375c44.793 0 81.238 36.449 81.238 81.242v141.488c0 27.758-22.578 50.34-50.34 50.34zM122.199 123.008c-37.265 0-67.586 30.32-67.586 67.586v141.488c0 20.223 16.461 36.684 36.688 36.684h220.172c20.226 0 36.687-16.461 36.687-36.684V190.594c0-37.266-30.32-67.586-67.586-67.586zm0 0",
  fill: "#4c241d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M146.27 259.441c0 16.489-13.364 29.852-29.852 29.852-16.484 0-29.852-13.363-29.852-29.852 0-16.484 13.368-29.851 29.852-29.851 16.488 0 29.852 13.367 29.852 29.851zm0 0",
  fill: "#a9ba5a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M116.422 296.121c-20.23 0-36.68-16.453-36.68-36.672 0-20.23 16.453-36.68 36.68-36.68 20.223 0 36.68 16.454 36.68 36.68 0 20.219-16.457 36.672-36.68 36.672zm0-59.703c-12.7 0-23.027 10.328-23.027 23.027 0 12.696 10.328 23.02 23.027 23.02s23.023-10.328 23.023-23.02c0-12.699-10.324-23.027-23.023-23.027zm0 0",
  fill: "#4c241d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M309.18 259.441c0 16.489-13.368 29.852-29.852 29.852-16.488 0-29.851-13.363-29.851-29.852 0-16.484 13.363-29.851 29.851-29.851 16.485 0 29.852 13.367 29.852 29.851zm0 0",
  fill: "#a9ba5a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M279.328 296.121c-20.23 0-36.68-16.453-36.68-36.672 0-20.23 16.454-36.68 36.68-36.68 20.223 0 36.68 16.454 36.68 36.68 0 20.219-16.453 36.672-36.68 36.672zm0-59.703c-12.7 0-23.027 10.328-23.027 23.027 0 12.696 10.328 23.02 23.027 23.02s23.024-10.328 23.024-23.02c0-12.699-10.325-23.027-23.024-23.027zm0 0M201.434 331.992c-12.641 0-25.426-3.144-38.27-9.445-3.383-1.652-4.777-5.746-3.117-9.133 1.652-3.375 5.746-4.8 9.133-3.121 21.941 10.754 42.715 10.773 63.52.059a6.81 6.81 0 019.195 2.941c1.726 3.355.414 7.473-2.942 9.195-12.305 6.34-24.84 9.504-37.52 9.504zm0 0",
  fill: "#4c241d"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M416.426 41.086H238.934v102.402h40.96v37.235l33.387-37.235h103.145zm0 0",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  fill: "#4c241d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M279.895 187.547c-.82 0-1.649-.149-2.442-.453a6.825 6.825 0 01-4.387-6.375v-30.406h-34.132a6.822 6.822 0 01-6.829-6.825V41.086a6.822 6.822 0 016.829-6.824h177.492a6.822 6.822 0 016.828 6.824v102.402a6.822 6.822 0 01-6.828 6.825H316.328l-31.355 34.968a6.817 6.817 0 01-5.078 2.266zm-34.133-50.887h34.133a6.822 6.822 0 016.824 6.828v19.39l21.48-23.952a6.826 6.826 0 015.082-2.266h96.32V47.914h-163.84zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.355 81.668h-39.449a6.822 6.822 0 01-6.824-6.828 6.822 6.822 0 016.824-6.828h39.45a6.822 6.822 0 016.824 6.828 6.822 6.822 0 01-6.825 6.828zm0 0M389.121 115.8H269.906a6.825 6.825 0 01-6.828-6.827 6.825 6.825 0 016.828-6.828h119.215a6.822 6.822 0 016.824 6.828 6.822 6.822 0 01-6.824 6.828zm0 0"
}));

var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 564,
    viewBox: "0 -20 423.253 423",
    width: 564
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default SvgAi;